import styles from "./button.module.css";

const Button = ({ children, functionallity, size, variant }) => {
  return (
    <button
      type="button"
      onClick={functionallity}
      className={`${styles.button} ${styles[size]} ${styles[variant]}`}
    >
      {children}
    </button>
  );
};

export default Button;
